import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Permission } from '../common/enums/permissions';
import { AuthGuard } from '../core/authentication/auth.guard';
import { PermissionGuard } from '../core/authentication/permission.guard';
import { HasPermissionToModuleGuard, ModuleName } from '../subscription-package';
import { DateTime } from 'luxon';
import { HolidayListComponent } from './holiday-list/holiday-list.component';
import { HolidayPerMonthListComponent } from './holiday-per-month-list/holiday-per-month-list.component';

const routes: Routes = [
  {
    path: 'holidays',
    component: HolidayListComponent,
    canActivate: [
      AuthGuard,
      PermissionGuard,
      HasPermissionToModuleGuard
    ],
    data: {
      permissions: [
        Permission.ViewAllPresencesPerMonth,
        Permission.Supervisor,
        Permission.ViewAllExternalWorkersHolidaysList,
        Permission.ViewMyExternalWorkersHolidaysList,
      ],
      moduleName: ModuleName.Holidays
    },
    children: [
      {
        path: '',
        redirectTo: DateTime.now().toFormat('yyyy/MM'),
        pathMatch: 'full',
      },
      {
        path: ':year/:month',
        component: HolidayPerMonthListComponent,
        pathMatch: 'full',
        canActivate: [AuthGuard, PermissionGuard],
        data: { permissions: [Permission.ViewAllExternalWorkersHolidaysList, Permission.ViewMyExternalWorkersHolidaysList, Permission.Supervisor] },
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class HolidaysRoutingModule { }
